import { IInventoryCountDetail } from './IInventoryCountDetail';
import { IInventoryCounter } from './IInventoryCounter';

export interface IInventoryGroup {
  groupId: string;
  groupName: string;
  items?: IInventoryCountDetail[];
  completePercent?: number;
  countsStarted?: number;
  short?: number;
  over?: number;
  broken?: number;
  hasNotes?: boolean;
  tethering?: number;
  counters: IInventoryCounter[];
}
